import React, { useState, useEffect,useRef,button  } from 'react';
// import { MDBTable, MDBTableHead, MDBTableBody } from 'mdb-react-ui-kit';
import './ActiveList.css';
import { getPmsUserList } from "../Services/Service";
// import ReactPaginate from "react-paginate";
import { Link } from "react-router-dom";
import $ from 'jquery'; 
import Table from './DataTable/DataTable';
import { CustomLoader } from "../Services/CommonLibrary"
import * as XLSX from "xlsx"

function UserList() {

    const tableRef = useRef(null);

    const clickhandler = name => console.log("delete", name);
    const [serviceData, setServiceData] = useState([]);
    const [loading, setLoading] = useState(true);

    const [limit, setLimit] = useState(10);
    const [totalData, setTotalData] = useState('');

    const accessFrom= localStorage.getItem('access');

    useEffect(() => {
        fetchActiveList(1, limit, '');
        
    }, []);




    const fetchActiveList = async (currentPage, limit, filterEvent) => {

        getPmsUserList(currentPage, limit, filterEvent, '')
            .then((res) => {
                setServiceData(res.data.data);
                setTotalData(res.data.total);
                setLoading(false);
            }
        );
    }

   const handleExport = () => {
        const current = new Date();
        const date = `${current.getDate()}-${current.getMonth()+1}-${current.getFullYear()}`;
        var wb = XLSX.utils.book_new();
        var ws = XLSX.utils.json_to_sheet(serviceData);
        XLSX.utils.book_append_sheet(wb, ws, "UserList");
        XLSX.writeFile(wb,`User List ${date}.csv`);
   }

   

    const columns = [
        {name: "Username",selector: row => <div  className='tdData'>{row.userName}</div>,sortable: true,grow: 2},
        {name: "Email",selector: row =>    <div style={{width:'1000px'}} className='tdData'>{row.email}</div>,sortable: true,grow: 2},
        {name: "Name",selector: row =>     <div  className='tdData'>{row.name}</div>,sortable: true,grow: 2},
        {name: "Role",selector: row =>     <div  className='tdData'>{row.role}</div>,sortable: true,grow: 2},
        {name: "Last Login Time",selector: row => <div className='tdData'>{row.lastLoginTime}</div>,sortable: true,grow: 2},
        {name: "Status",selector: row => row.status,sortable: true,grow: 2,
            conditionalCellStyles: [
                {
                    when: row => row.status ==  'Active',
                    style: {color: 'green'},
                },
                {
                    when: row => row.status ==  'Inactive',
                    style: {color: 'red'},
                },
            
            
            ],
        },
        {name: "Inactivated By",selector: row => <div className='tdData'>{row.updatedByUser}</div>,sortable: true,grow: 2},
        {name: "Inactive Date",selector: row => <div className='tdData'>{row.updateDate}</div>,sortable: true,grow: 2},
        {
            name: "Edit",
            button: true,
            omit: (accessFrom=='superadmin') ? false : true ,
            cell: row =>
              
                <>
                  {(accessFrom=='superadmin') ?<Link className='btn btn-secondary btn-sm btn-edit' to={`/user-add/${row.id}`}>Edit</Link>:null}
                </>
             
          }
      ];
    const DataTableTitle = <><h1 className="title">User Management &nbsp;&nbsp;&nbsp; {(accessFrom=='superadmin') ?<Link className='btn btn-primary btn-edit' to={`/user-add`}>Add New User</Link> : null}</h1></>
    return (
        <section className='projects-section'>
            <div className='row'>
                <div className="FL">
                    <div className="row mb-3 align-items-center displayFlexSms">
                        <div className="col-md-10">
                            {/* <h1 className="title">User Management &nbsp;&nbsp;&nbsp; {(accessFrom=='superadmin') ?<Link className='btn btn-primary btn-edit' to={`/user-add`}>Add New User</Link> : null}</h1><br /> */}
                            {/* <h3 className="title">Total - {totalData}</h3> */}
                            {/* <button onClick={handleExport}>DOWNLOAD</button> */}
                        </div>
                    </div>
                    <div className='table-responsive userlistdatable'>
                        <Table data={serviceData}  column={columns} title={DataTableTitle} filterRole='true' filterActiveInactive="true" showFilter="true" />
                    </div>
                </div>
            </div>
            { loading ? <CustomLoader /> : null }
        </section>



    );
}
export default UserList;